import React from 'react'

import styled, { useTheme } from 'styled-components/native'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { NumberBadge } from '../../atoms/icons/NumberBadge'
import { PressableOpacity } from '../../atoms/pressableOpacity/PressableOpacity'

export type UtilityButtonProps = {
  active?: boolean
  onPress: () => void
  leftIcon: React.ReactElement
  text: React.ReactElement
  testID?: string
  counter?: number
}

const UtilityButtonContainer = styled(PressableOpacity)<{ active?: boolean }>(({ theme, active }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: `5px ${theme.spacing['12px']}`,
  marginTop: '3px',
  marginBottom: '3px',
  backgroundColor: active ? theme.colors.backgroundSection : theme.colors.backgroundPrimary,
  borderRadius: '8px',
}))
const InnerContainer = styled.View(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing['8px'],
}))

const Counter = styled(NumberBadge)({
  alignSelf: 'center',
  borderRadius: '4px',
})

export const UtilityButton = ({ active, onPress, leftIcon, text, testID, counter }: UtilityButtonProps) => {
  const theme = useTheme()
  return (
    <UtilityButtonContainer
      testID={testID}
      active={active}
      onPress={onPress}
      pressedBackgroundColor={theme.colors.backgroundSection}
    >
      <InnerContainer>
        {leftIcon}
        <BodyText text={text} />
      </InnerContainer>
      {counter ? (
        <Counter number={counter} backgroundColor={theme.colors.components.utilityItemBadge.fill} />
      ) : undefined}
    </UtilityButtonContainer>
  )
}
